"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGasketInSlot = exports.getExtrusionsAndCornersQuantity = exports.getStartDirection = exports.isSlotIntersectFastener = exports.getConnectionPosition = exports.getConnectionFastenerData = exports.getSlotSurfacePlane = exports.getSlotBottomPlane = exports.getBottomPanelInSlotPoint = exports.getNotchPlane = exports.createExtrudeGeometry = exports.rotateContourInXY = exports.getContourMaxCorner = exports.getMinPoint = exports.getClosestExtrusion = exports.isVerticalToPanelExtrusion = exports.isInPlaneToPanelObject = exports.isSlotInPlane = exports.createWireMeshGeometry = exports.getPanelNormal = exports.getContourDirectionForVerticalExtrusions = exports.getInSlotItemsContourDirection = exports.getNearestSlot = exports.arePerpendicularSlots = exports.getSlotsLoopDirection = exports.getPlanesIntersection = exports.getStartPosition = exports.getOppositeSlot = exports.getPanelEdges = exports.getSolidWireIntervals = void 0;
const three_1 = require("three");
const three_mesh_bvh_1 = require("three-mesh-bvh");
// eslint-disable-next-line import/extensions
const BufferGeometryUtils = __importStar(require("three/examples/jsm/utils/BufferGeometryUtils.js"));
const __1 = require("..");
const consts_1 = require("../../consts");
const utils_1 = require("../../utils");
const Viewer_1 = __importDefault(require("../../Viewer"));
const PanelInSlotsConsts_1 = require("./PanelInSlotsConsts");
const utils_3d_1 = require("../../utils/utils.3d");
const tempVector1 = new three_1.Vector3();
const tempVector2 = new three_1.Vector3();
function getSolidWireIntervals(panelIntersections1, panelIntersections2, coordinateIndex) {
    const solidIntervals = [];
    if (!panelIntersections1.length || !panelIntersections2.length) {
        return solidIntervals;
    }
    const loopIntersectionPoints = [];
    if (panelIntersections1.length <= panelIntersections2.length) {
        panelIntersections1.forEach((panelIntersection) => loopIntersectionPoints.push(panelIntersection.point));
    }
    else {
        for (let i = 0; i < panelIntersections2.length; i += 1) {
            const point = panelIntersections1[0].point.clone();
            point.setComponent(coordinateIndex, panelIntersections2[i].point.getComponent(coordinateIndex));
            loopIntersectionPoints.push(point);
        }
    }
    for (let i = 0; i < loopIntersectionPoints.length; i += 2) {
        if (i > loopIntersectionPoints.length) {
            break;
        }
        solidIntervals.push({ startPoint: loopIntersectionPoints[i], endPoint: loopIntersectionPoints[i + 1] });
    }
    return solidIntervals;
}
exports.getSolidWireIntervals = getSolidWireIntervals;
function getPanelEdges(object) {
    const result = [];
    const panel = object;
    const centralPoints = panel.getTransformedCutContour();
    const addContourLines = (shift) => {
        centralPoints.forEach((point, pointIndex) => {
            const nextPointIndex = pointIndex < centralPoints.length - 1 ? pointIndex + 1 : 0;
            if (shift) {
                result.push(new three_1.Line3(point.clone().add(shift), centralPoints[nextPointIndex].clone().add(shift)));
            }
            else {
                result.push(new three_1.Line3(point.clone(), centralPoints[nextPointIndex].clone()));
            }
        });
    };
    addContourLines(null);
    addContourLines(panel.directionNormal.clone().multiplyScalar(panel.getThickness()));
    return result;
}
exports.getPanelEdges = getPanelEdges;
function getOppositeSlot(panelPlane, object, currentSlot) {
    var _a;
    const currentSlotNormal = currentSlot.normal;
    const oppositeSlots = (_a = object.getSlots()) === null || _a === void 0 ? void 0 : _a.filter((slot) => {
        return (utils_1.Utils.areVectorsCollinear(slot.normal, currentSlotNormal) &&
            !utils_1.Utils.areVectorsEqual(slot.normal, currentSlotNormal));
    });
    if (!(oppositeSlots === null || oppositeSlots === void 0 ? void 0 : oppositeSlots.length)) {
        return null;
    }
    const oppositeSlot = oppositeSlots.find((slot) => {
        return utils_1.Utils.roundTo3(panelPlane.distanceToPoint(slot.surfacePoint)) === 0;
    });
    return oppositeSlot !== null && oppositeSlot !== void 0 ? oppositeSlot : null;
}
exports.getOppositeSlot = getOppositeSlot;
function getStartPosition(intersectionPoint, selectedSlot) {
    return selectedSlot.surfacePoint
        .clone()
        .projectOnPlane(selectedSlot.direction)
        .add(new three_1.Vector3().copy(intersectionPoint).projectOnVector(selectedSlot.direction));
}
exports.getStartPosition = getStartPosition;
function getPlanesIntersection(plane1, plane2, plane3) {
    const n1 = plane1.normal;
    const n2 = plane2.normal;
    const n3 = plane3.normal;
    const x1 = plane1.coplanarPoint(new three_1.Vector3());
    const x2 = plane2.coplanarPoint(new three_1.Vector3());
    const x3 = plane3.coplanarPoint(new three_1.Vector3());
    const f1 = new three_1.Vector3().crossVectors(n2, n3).multiplyScalar(x1.dot(n1));
    const f2 = new three_1.Vector3().crossVectors(n3, n1).multiplyScalar(x2.dot(n2));
    const f3 = new three_1.Vector3().crossVectors(n1, n2).multiplyScalar(x3.dot(n3));
    const det = new three_1.Matrix3().set(n1.x, n1.y, n1.z, n2.x, n2.y, n2.z, n3.x, n3.y, n3.z).determinant();
    const vectorSum = new three_1.Vector3().add(f1).add(f2).add(f3);
    return new three_1.Vector3(vectorSum.x / det, vectorSum.y / det, vectorSum.z / det);
}
exports.getPlanesIntersection = getPlanesIntersection;
function getSlotsLoopDirection(slotsCount, connectedSlotsNumbers, startNotConnectedSlotNumber) {
    const minConnectedNumber = Math.min(...connectedSlotsNumbers);
    const maxConnectedNumber = Math.max(...connectedSlotsNumbers);
    if (startNotConnectedSlotNumber === 1) {
        return maxConnectedNumber === slotsCount ? 1 : -1;
    }
    if (startNotConnectedSlotNumber === slotsCount) {
        return minConnectedNumber === 1 ? -1 : 1;
    }
    return startNotConnectedSlotNumber < minConnectedNumber ? -1 : 1;
}
exports.getSlotsLoopDirection = getSlotsLoopDirection;
function arePerpendicularSlots(currentSlot, nextSlot) {
    return utils_1.Utils.areEqual(Math.abs(currentSlot.normal.angleTo(nextSlot.normal)), Math.PI / 2);
}
exports.arePerpendicularSlots = arePerpendicularSlots;
function getNearestSlot(panelPosition, slots) {
    const nearestSlotPosition = utils_1.Utils.getNearestPoint(panelPosition, slots.map((slot) => slot.surfacePoint));
    return slots.find((slot) => slot.surfacePoint === nearestSlotPosition);
}
exports.getNearestSlot = getNearestSlot;
function getInSlotItemsContourDirection(currentDirection, nextExtrusion, currentSlot) {
    const dotRes = utils_1.Utils.roundTo3(currentSlot.normal.dot(nextExtrusion.directionNormal));
    if (dotRes === 0) {
        return currentDirection;
    }
    if (dotRes > 0) {
        return nextExtrusion.directionNormal;
    }
    return nextExtrusion.directionNormal.clone().negate();
}
exports.getInSlotItemsContourDirection = getInSlotItemsContourDirection;
function getContourDirectionForVerticalExtrusions(currentDirection, currentSlotNormal, nextSlotNormal) {
    if (utils_1.Utils.areVectorsEqual(currentDirection, nextSlotNormal)) {
        return currentSlotNormal.clone().negate();
    }
    if (utils_1.Utils.areVectorsCollinear(currentDirection, nextSlotNormal)) {
        return currentSlotNormal;
    }
    if (utils_1.Utils.areVectorsEqual(currentSlotNormal, nextSlotNormal)) {
        return currentDirection;
    }
    return currentDirection.clone().negate();
}
exports.getContourDirectionForVerticalExtrusions = getContourDirectionForVerticalExtrusions;
function getPanelNormal(slot) {
    return utils_1.Utils.absVector(slot.direction.clone().cross(slot.normal));
}
exports.getPanelNormal = getPanelNormal;
function createWireMeshGeometry(cylinderRadius, horizontalStep, verticalStep, thickness, panelMesh) {
    const geometryBox = panelMesh.geometry.boundingBox;
    if (!geometryBox) {
        return null;
    }
    const lengthX = Math.abs(geometryBox.max.x - geometryBox.min.x);
    const lengthY = Math.abs(geometryBox.max.y - geometryBox.min.y);
    const boxCenter = geometryBox.getCenter(new three_1.Vector3());
    const minPoint = new three_1.Vector3().set(boxCenter.x < geometryBox.min.x ? geometryBox.min.x : geometryBox.max.x, boxCenter.y < geometryBox.min.y ? geometryBox.min.y : geometryBox.max.y, -thickness / 2);
    const mergedGeometries = [];
    let cylinderNumX = Math.floor(lengthX / horizontalStep);
    let cylinderNumY = Math.floor(lengthY / verticalStep);
    if (lengthX % horizontalStep >= 0.25) {
        cylinderNumX += 1;
    }
    if (lengthY % verticalStep >= 0.25) {
        cylinderNumY += 1;
    }
    const numRadialSegments = 24;
    const ray = new three_1.Raycaster();
    const tempPanelMesh = panelMesh.clone();
    tempPanelMesh.updateMatrixWorld();
    tempPanelMesh.visible = false;
    Viewer_1.default.instance.getScene().add(tempPanelMesh);
    const yDirection = new three_1.Vector3(0, -1, 0);
    tempVector1.copy(minPoint);
    tempVector2.set(minPoint.x - cylinderRadius * 2, minPoint.y, minPoint.z);
    for (let i = 0; i < cylinderNumX; i += 1) {
        ray.set(tempVector1, yDirection);
        const panelIntersections1 = ray.intersectObject(tempPanelMesh);
        ray.set(tempVector2, yDirection);
        const panelIntersections2 = ray.intersectObject(tempPanelMesh);
        const solidIntervals = getSolidWireIntervals(panelIntersections1, panelIntersections2, 1);
        solidIntervals.forEach((solidInterval) => {
            const cylinderLength = Math.abs(solidInterval.endPoint.y - solidInterval.startPoint.y);
            if (cylinderLength > horizontalStep) {
                const geometry = new three_1.CylinderGeometry(cylinderRadius, cylinderRadius, cylinderLength, numRadialSegments);
                const { startPoint } = solidInterval;
                geometry.translate(startPoint.x, startPoint.y - cylinderLength / 2, startPoint.z - cylinderRadius);
                mergedGeometries.push(geometry);
            }
        });
        tempVector1.x += -horizontalStep;
        tempVector2.x = tempVector1.x - cylinderRadius * 2;
    }
    const xDirection = new three_1.Vector3(-1, 0, 0);
    tempVector1.copy(minPoint);
    tempVector2.set(minPoint.x, minPoint.y - cylinderRadius * 2, minPoint.z);
    for (let i = 0; i < cylinderNumY; i += 1) {
        ray.set(tempVector1, xDirection);
        const panelIntersections1 = ray.intersectObject(tempPanelMesh);
        ray.set(tempVector2, xDirection);
        const panelIntersections2 = ray.intersectObject(tempPanelMesh);
        const solidIntervals = getSolidWireIntervals(panelIntersections1, panelIntersections2, 0);
        solidIntervals.forEach((solidInterval) => {
            const cylinderLength = Math.abs(solidInterval.endPoint.x - solidInterval.startPoint.x);
            if (cylinderLength > verticalStep) {
                const geometry = new three_1.CylinderGeometry(cylinderRadius, cylinderRadius, cylinderLength, numRadialSegments);
                geometry.rotateZ(Math.PI / 2);
                const { startPoint } = solidInterval;
                geometry.translate(startPoint.x - cylinderLength / 2, startPoint.y - cylinderRadius, startPoint.z + thickness / 2 - cylinderRadius);
                mergedGeometries.push(geometry);
            }
        });
        tempVector1.y += -verticalStep;
        tempVector2.y = tempVector1.y - cylinderRadius * 2;
    }
    Viewer_1.default.instance.getScene().remove(tempPanelMesh);
    if (mergedGeometries.length) {
        return BufferGeometryUtils.mergeGeometries(mergedGeometries, true);
    }
    return null;
}
exports.createWireMeshGeometry = createWireMeshGeometry;
function isSlotInPlane(panelPlane, slot) {
    return utils_1.Utils.roundTo3(panelPlane.distanceToPoint(slot.surfacePoint)) === 0;
}
exports.isSlotInPlane = isSlotInPlane;
function isInPlaneToPanelObject(panelPlane, object) {
    if ((0, utils_3d_1.isExtrusion)(object)) {
        const slots = object.getSlots();
        if (!slots || !slots.length) {
            return false;
        }
        for (let i = 0; i < slots.length; i += 1) {
            if (isSlotInPlane(panelPlane, slots[i])) {
                return true;
            }
        }
        return false;
    }
    if (object instanceof __1.ComponentObjectsBase && object.isCornerComponent) {
        const componentCenter = utils_1.Utils.getAABBoxCenter(object);
        return utils_1.Utils.roundTo3(panelPlane.distanceToPoint(componentCenter)) === 0;
    }
    return false;
}
exports.isInPlaneToPanelObject = isInPlaneToPanelObject;
function isVerticalToPanelExtrusion(panelPlane, object) {
    if (!utils_1.Utils.areVectorsEqual(object.directionNormal, panelPlane.normal) &&
        !utils_1.Utils.areVectorsEqual(object.directionNormal.clone().negate(), panelPlane.normal)) {
        return false;
    }
    if (!(0, utils_3d_1.isExtrusion)(object)) {
        return false;
    }
    return panelPlane.intersectsBox(utils_1.Utils.getAABBox(object));
}
exports.isVerticalToPanelExtrusion = isVerticalToPanelExtrusion;
function getClosestExtrusion(panelPlane, startPoint, direction, extrusionSlot, extrusions) {
    let minDistance = Infinity;
    let resultExtrusion;
    let resultSlot;
    let resultStartPosion;
    const currentObjectSufracePlane = new three_1.Plane().setFromNormalAndCoplanarPoint(extrusionSlot.normal, extrusionSlot.surfacePoint);
    const tempPlane = new three_1.Plane();
    extrusions.forEach((object) => {
        const objectSlot = getNearestSlot(startPoint, object.getSlots());
        const objectStartPosition = getPlanesIntersection(panelPlane, currentObjectSufracePlane, tempPlane.setFromNormalAndCoplanarPoint(objectSlot.normal, objectSlot.surfacePoint));
        if (!objectStartPosition) {
            return;
        }
        const distanceToObject = utils_1.Utils.roundTo3(tempVector1.subVectors(objectStartPosition, startPoint).dot(direction));
        if (distanceToObject >= 0 && distanceToObject < minDistance) {
            resultExtrusion = object;
            resultSlot = objectSlot;
            resultStartPosion = objectStartPosition;
            minDistance = distanceToObject;
        }
    });
    return resultExtrusion ? { extrusion: resultExtrusion, slot: resultSlot, startPosition: resultStartPosion } : null;
}
exports.getClosestExtrusion = getClosestExtrusion;
function getMinPoint(points) {
    const minPoints = utils_1.Utils.getPointsOnMinCoord(points, consts_1.consts.DIRECTIONS_LIST[consts_1.consts.AXES.negativeX], consts_1.consts.DIRECTIONS_LIST[consts_1.consts.AXES.negativeY]);
    let minPoint = minPoints[0];
    minPoints.forEach((point) => {
        if (point.z < minPoint.z) {
            minPoint = point;
        }
    });
    return minPoint;
}
exports.getMinPoint = getMinPoint;
function getContourMaxCorner(contourPoints) {
    return new three_1.Box3().setFromPoints(contourPoints).max;
}
exports.getContourMaxCorner = getContourMaxCorner;
function rotateContourInXY(contourPoints, contourNormal) {
    const rotation = new three_1.Quaternion().setFromUnitVectors(contourNormal, consts_1.consts.DP_UP_DIR);
    return contourPoints.map((point) => point.clone().applyQuaternion(rotation));
}
exports.rotateContourInXY = rotateContourInXY;
function createExtrudeGeometry(contourPoints, height, normal, holeContours = []) {
    const rotatedPoints = rotateContourInXY(contourPoints, normal);
    const shift = getContourMaxCorner(rotatedPoints);
    rotatedPoints.forEach((point) => {
        point.sub(shift);
    });
    const points2D = rotatedPoints.map((point) => new three_1.Vector2(point.x, point.y)); // get2DVector(point));
    const maxY = points2D
        .map((point) => point.y)
        .reduce((y1, y2) => {
        return y1 > y2 ? y1 : y2;
    }, -Infinity);
    const points2DWithMaxY = points2D.filter((point) => point.y === maxY);
    const maxX = points2DWithMaxY
        .map((point) => point.x)
        .reduce((x1, x2) => {
        return x1 > x2 ? x1 : x2;
    }, -Infinity);
    const startPoint = points2DWithMaxY.filter((point) => point.x === maxX)[0];
    let currIndex = points2D.findIndex((point) => point.x === startPoint.x && point.y === startPoint.y);
    const reorderedPoints = [points2D[currIndex]];
    let i = 1;
    while (i < points2D.length) {
        const neighborPoints = [];
        const prevIndex = currIndex !== 0 ? currIndex - 1 : points2D.length - 1;
        if (!reorderedPoints.includes(points2D[prevIndex])) {
            neighborPoints.push(points2D[prevIndex]);
        }
        const nextIndex = currIndex !== points2D.length - 1 ? currIndex + 1 : 0;
        if (!reorderedPoints.includes(points2D[nextIndex])) {
            neighborPoints.push(points2D[nextIndex]);
        }
        let nextPoint;
        if (neighborPoints.length === 2) {
            nextPoint = neighborPoints[0].y < neighborPoints[1].y ? neighborPoints[0] : neighborPoints[1];
        }
        else {
            [nextPoint] = neighborPoints;
        }
        reorderedPoints.push(nextPoint);
        currIndex = points2D.indexOf(nextPoint);
        i += 1;
    }
    const shape = new three_1.Shape(reorderedPoints);
    const resultHoleContours = holeContours.map((hole) => {
        const rotatedHole = rotateContourInXY(hole, normal).map((point) => point.sub(shift));
        shape.holes.push(new three_1.Path(rotatedHole.map((point) => new three_1.Vector2(point.x, point.y))));
        return rotatedHole.map((point) => new three_1.Vector3(point.x, point.y, 0));
    });
    const extrudeSettings = {
        steps: 1,
        depth: -height,
        bevelEnabled: false,
    };
    const extrudeGeometry = new three_1.ExtrudeGeometry(shape, extrudeSettings);
    const resultPoints = reorderedPoints.map((point2D) => new three_1.Vector3(point2D.x, point2D.y, 0));
    const bufferGeometry = BufferGeometryUtils.mergeVertices(extrudeGeometry);
    bufferGeometry.boundsTree = new three_mesh_bvh_1.MeshBVH(bufferGeometry);
    return { geometry: bufferGeometry, resultPoints, resultHoleContours };
}
exports.createExtrudeGeometry = createExtrudeGeometry;
function getNotchPlane(plane) {
    const onPlanePoint = new three_1.Vector3();
    plane.coplanarPoint(onPlanePoint);
    onPlanePoint.add(plane.normal.clone().multiplyScalar(PanelInSlotsConsts_1.notchDistance));
    return new three_1.Plane().setFromNormalAndCoplanarPoint(plane.normal, onPlanePoint);
}
exports.getNotchPlane = getNotchPlane;
function getBottomPanelInSlotPoint(slot) {
    const maxSlotDepth = tempVector1
        .copy(slot.surfacePoint)
        .projectOnVector(slot.normal)
        .sub(tempVector2.copy(slot.points[0]).projectOnVector(slot.normal))
        .length();
    if (slot.depth && slot.depth < maxSlotDepth) {
        return tempVector1.copy(slot.surfacePoint).add(tempVector2.copy(slot.normal).negate().multiplyScalar(slot.depth));
    }
    return tempVector1.copy(slot.points[0]).add(tempVector2.copy(slot.normal).multiplyScalar(consts_1.consts.TWO_FLOAT_EPSILON));
}
exports.getBottomPanelInSlotPoint = getBottomPanelInSlotPoint;
function getSlotBottomPlane(slot) {
    const bottomPoint = getBottomPanelInSlotPoint(slot);
    return new three_1.Plane().setFromNormalAndCoplanarPoint(slot.normal, bottomPoint);
}
exports.getSlotBottomPlane = getSlotBottomPlane;
function getSlotSurfacePlane(slot, forNotch) {
    const surfacePlane = new three_1.Plane().setFromNormalAndCoplanarPoint(slot.normal, slot.surfacePoint);
    return forNotch ? getNotchPlane(surfacePlane) : surfacePlane;
}
exports.getSlotSurfacePlane = getSlotSurfacePlane;
function getConnectionFastenerData(startPoint, panelPlane, firstObject, secondObject, fastenerType = null) {
    var _a;
    const viewer = Viewer_1.default.instance;
    const { connectionManager } = viewer.getDesignProMain();
    const connectionObject = (_a = connectionManager.getConnectionObject(firstObject.uuid, secondObject.uuid)) !== null && _a !== void 0 ? _a : connectionManager.getConnectionObject(secondObject.uuid, firstObject.uuid);
    const fasteners = connectionObject === null || connectionObject === void 0 ? void 0 : connectionObject.getFasteners().filter((fastener) => !fastenerType || fastener.fastenerType === fastenerType);
    if (!fasteners) {
        return null;
    }
    const inPlaneFasteners = [];
    for (let i = 0; i < fasteners.length; i += 1) {
        const fastener = fasteners[i];
        const currentFastenerBox = utils_1.Utils.getAABBox(fastener);
        if (panelPlane.intersectsBox(currentFastenerBox)) {
            inPlaneFasteners.push({ fastener, box: currentFastenerBox });
        }
    }
    if (inPlaneFasteners.length === 1) {
        const fastenerData = inPlaneFasteners[0];
        return { id: fastenerData.fastener.uuid, box: fastenerData.box };
    }
    const minFastenerCoordinate = utils_1.Utils.getNearestPoint(startPoint, inPlaneFasteners.map((data) => data.box.min));
    const closestFastenerData = inPlaneFasteners.find((data) => data.box.min === minFastenerCoordinate);
    return closestFastenerData ? { id: closestFastenerData.fastener.uuid, box: closestFastenerData.box } : null;
}
exports.getConnectionFastenerData = getConnectionFastenerData;
function getConnectionPosition(firstObject, secondObject) {
    var _a;
    const { connectionManager } = Viewer_1.default.instance.getDesignProMain();
    let mainObject;
    let connectedObject;
    let connectionObject = connectionManager.getConnectionObject(firstObject.uuid, secondObject.uuid);
    if (connectionObject) {
        mainObject = firstObject;
        connectedObject = secondObject;
    }
    connectionObject !== null && connectionObject !== void 0 ? connectionObject : (connectionObject = connectionManager.getConnectionObject(secondObject.uuid, firstObject.uuid));
    if (connectionObject) {
        mainObject = secondObject;
        connectedObject = firstObject;
    }
    if (!connectionObject || !mainObject || !connectedObject) {
        return null;
    }
    const connectionSphere = connectionObject === null || connectionObject === void 0 ? void 0 : connectionObject.getSphere();
    if (connectionSphere) {
        return connectionSphere.position;
    }
    return (_a = utils_1.Utils.computeSnapPosition(mainObject, connectedObject)) !== null && _a !== void 0 ? _a : null;
}
exports.getConnectionPosition = getConnectionPosition;
function isSlotIntersectFastener(slot, fastenerBox) {
    const bottomPlane = getSlotBottomPlane(slot);
    const expandedBox = fastenerBox.clone().expandByScalar(-PanelInSlotsConsts_1.fastenerBoxExpand);
    if (bottomPlane.intersectsBox(expandedBox)) {
        return true;
    }
    const surfacePlane = getSlotSurfacePlane(slot, false);
    return surfacePlane.intersectsBox(expandedBox);
}
exports.isSlotIntersectFastener = isSlotIntersectFastener;
// counterclockwise direction for contour
function getStartDirection(slotDirection, slotNormal) {
    const normalX = utils_1.Utils.roundTo3(slotNormal.x);
    const normalY = utils_1.Utils.roundTo3(slotNormal.y);
    const normalZ = utils_1.Utils.roundTo3(slotNormal.z);
    const absDirection = utils_1.Utils.absVector(slotDirection.clone());
    const absDirectionX = utils_1.Utils.roundTo3(absDirection.x);
    const absDirectionY = utils_1.Utils.roundTo3(absDirection.y);
    const resultVector = new three_1.Vector3();
    if (normalX > 0) {
        return absDirectionY > 0 ? resultVector.set(0, 1, 0) : resultVector.set(0, 0, 1);
    }
    if (normalX < 0) {
        return absDirectionY > 0 ? resultVector.set(0, -1, 0) : resultVector.set(0, 0, -1);
    }
    if (normalY > 0) {
        return absDirectionX > 0 ? resultVector.set(-1, 0, 0) : resultVector.set(0, 0, -1);
    }
    if (normalY < 0) {
        return absDirectionX > 0 ? resultVector.set(1, 0, 0) : resultVector.set(0, 0, 1);
    }
    if (normalZ > 0) {
        return absDirectionX > 0 ? resultVector.set(-1, 0, 0) : resultVector.set(0, 1, 0);
    }
    // normalZ < 0
    return absDirectionX > 0 ? resultVector.set(1, 0, 0) : resultVector.set(0, -1, 0);
}
exports.getStartDirection = getStartDirection;
function getExtrusionsAndCornersQuantity(viewer, connectionItems) {
    let quantity = 0;
    connectionItems.forEach((connectionItem) => {
        if (connectionItem.itemType === 'Extrusion') {
            quantity += 1;
        }
        if (connectionItem.itemType === 'Component') {
            const object = viewer.getObjectById(connectionItem.uuid);
            if (object && object instanceof __1.ComponentObjectsBase && object.isCornerComponent) {
                quantity += 1;
            }
        }
    });
    return quantity;
}
exports.getExtrusionsAndCornersQuantity = getExtrusionsAndCornersQuantity;
function isGasketInSlot(slot, startPoint, endPoint) {
    const { direction } = slot;
    const negateDirection = direction.clone().negate();
    const projectStartPoint = startPoint.clone().projectOnVector(direction);
    const projectEndPoint = endPoint.clone().projectOnVector(direction);
    const slotPoints = [
        utils_1.Utils.getSlotStartPosition(slot, direction).projectOnVector(direction),
        utils_1.Utils.getSlotStartPosition(slot, negateDirection).projectOnVector(direction),
    ];
    const isStartPointInSlot = utils_1.Utils.isVectorBetweenVectors(projectStartPoint, slotPoints[0], slotPoints[1]);
    const isEndPointInSlot = utils_1.Utils.isVectorBetweenVectors(projectEndPoint, slotPoints[0], slotPoints[1]);
    if (isStartPointInSlot && isEndPointInSlot) {
        return true;
    }
    const maxDistance = slot.depth * 2;
    if (!isStartPointInSlot && !slotPoints.some((slotPoint) => slotPoint.distanceTo(projectStartPoint) <= maxDistance)) {
        return false;
    }
    if (!isEndPointInSlot && !slotPoints.some((slotPoint) => slotPoint.distanceTo(projectEndPoint) <= maxDistance)) {
        return false;
    }
    return true;
}
exports.isGasketInSlot = isGasketInSlot;
